module.exports = __webpack_public_path__ + "img/头像框.86f58793.png";